import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class FloorStructures extends Component {
  render() {
    return (
      <EntityList apiRoute='api/floorstructures' title='Remorque - Structures de plancher' editTitle='Structure de plancher' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default FloorStructures;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/floorStructures.js
 **/